"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const LoadingComponent_1 = __importDefault(require("components/shared/LoadingComponent"));
require("./Button.scss");
function SecondaryButton({ customClass, disabled, onClick, fullWidth, children, datacy, onMouseEnter, onMouseLeave, active, height, customClassSpan, isLoading }) {
    return (react_1.default.createElement("button", { onMouseEnter: () => onMouseEnter && onMouseEnter(), onMouseLeave: () => onMouseLeave && onMouseLeave(), "data-cy": datacy, className: `
        btn secondary state-secondary-purple height-${height} items-center
        ${customClass}
        ${fullWidth ? 'full-width' : ''}
        ${disabled ? 'disabled' : ''}
        ${active ? 'active' : ''}`, onClick: (e) => onClick && onClick(e), disabled: isLoading || disabled },
        isLoading && (react_1.default.createElement(LoadingComponent_1.default, { hasText: false, className: "py-[0px] w-[24px] h-[24px] mr-[4px]" })),
        react_1.default.createElement("span", { className: `typography-button ${customClassSpan ? customClassSpan : ''}` }, children)));
}
SecondaryButton.defaultProps = {
    customClass: '',
    onClick: () => undefined,
    disabled: false,
    fullWidth: false,
    datacy: '',
    onMouseEnter: () => undefined,
    onNMouseLeave: () => undefined,
    active: false,
    height: 36,
    customClassSpan: false
};
exports.default = SecondaryButton;
